import { parseISO } from 'date-fns';

const calendarDate = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: 'long',
  day: '2-digit',
  year: 'numeric',
});

/** Preserve the server's UTC publication date in every browser timezone. */
export function formatNewsDate(value: string): string {
  // Keep strict ISO validation while giving date-only and offset-free timestamps
  // the same UTC interpretation as the server, including ISO's space separator.
  const date = !/[T ]/.test(value)
    ? `${value}T00:00:00Z`
    : /[T ]/.test(value) && !/(?:Z|[+-]\d{2}(?::?\d{2})?)$/.test(value)
    ? `${value}Z`
    : value;
  return calendarDate.format(parseISO(date));
}
